













































import { Component, Provide, Vue, Watch } from 'vue-property-decorator';
import { Card } from 'element-ui';
import NavBar from '@/components/layout/NavBar.vue';
import QuoteItem from '@/components/inquiry/quote/QuoteItem.vue';
import QuoteSettings from '@/components/inquiry/quote/QuoteSettings.vue';
import {
  fetchQuotes_inquiries_quotes,
  TransportationTypeEnum,
  CargoTypeEnum
} from '@/types/graphql/schemaTypes';
import { i18n } from '@/plugins/i18n';
import get from 'lodash/get';

@Component({
  components: {
    NavBar,
    QuoteItem,
    QuoteSettings,
    'el-card': Card
  }
})
export default class Calculator extends Vue {
  private selected = 0;
  private selectedQuote = '';

  private created() {
    this.$store.dispatch('Inquiry/resetSimulatedQuote');
  }

  private addQuote() {
    this.$store.dispatch('Inquiry/addSimulatedQuote').then(() => {
      this.$store.dispatch('Alert/addAlert', {
        type: 'success',
        message: i18n.t('success.added'),
        time: 5000
      });
    });
  }

  private copyQuote() {
    this.$store.dispatch('Inquiry/copySimulatedQuote', this.selected).then(() => {
      this.$store.dispatch('Alert/addAlert', {
        type: 'success',
        message: i18n.t('success.added'),
        time: 5000
      });
    });
  }

  get quotes() {
    return this.$store.getters['Inquiry/simulatedQuote'];
  }

  /**
   * the store can't catch the change in the deep array
  **/
  private reload() {
    this.$forceUpdate();
  }
}
